import { assertInInjectionContext, DestroyRef, inject } from '@angular/core'

export function ngOnDestroy(callback: () => void): void {
  assertInInjectionContext(ngOnDestroy)
  inject(DestroyRef).onDestroy(callback)
}
